export default __webpack_public_path__ + "static/media/cacti-club-logo.38d19630.png";